export default {
  'apply.form.rule.wx': '请添加微信获取申请资格',
  'apply.form.label.wx': '微信号',
  'apply.form.placeholder.wx': '请输入微信号',

  'apply.form.research.intro': '您的研究介绍',
  'apply.form.research.intro.placeholder': '请输入您的研究介绍',
  'apply.form.research.intro.max': '请输入不超过1000字的研究介绍',
  'apply.form.research.intro.required': '请输入研究介绍',
  'apply.form.professing.option1': '大模型开发者',
  'apply.form.professing.option2': '应用开发者',
  'apply.form.professing.option3': '数据服务商',
  'apply.form.professing.option4': '科研工作者',
  'apply.form.professing.option5': '其它',


  'apply.form.hasCoverNeeds': '是否满足研究需求',
  'apply.form.hasCoverNeeds.option1': '是',
  'apply.form.hasCoverNeeds.option2': '否',

  'apply.form.improve': '关于“万卷·丝路”多语言多模态语料库，您还有哪些改进建议或数据需求？',
  'apply.form.improve.placeholder': '请输入您的建议或数据需求',


  'apply.form.useFor': '使用数据的预期成果',
  'apply.form.useFor.placeholder': '请输入使用数据的预期成果',

  'wuanjuanPurposeOptions.option1': '语言模型微调与性能优化',
  'wuanjuanPurposeOptions.option2': '语音智能助手应用开发',
  'wuanjuanPurposeOptions.option3': '跨语言企业出海智能工具研发',
  'wuanjuanPurposeOptions.option4': '小语种大模型评价与优化机制研究',
  'wuanjuanPurposeOptions.option5': '小语种语料库建设与开放',
  'wuanjuanPurposeOptions.option6': '小语种对话模型对齐评测基准构建',
  'wuanjuanPurposeOptions.option7': '多语言语料的自动标注与生成工具开发',
  'wuanjuanPurposeOptions.option8': '多语言智能教育系统的研发与开发',
  'wuanjuanPurposeOptions.option9': '其它',


};
